import { render, staticRenderFns } from "./LongFormModalRow.vue?vue&type=template&id=0dd6233d"
import script from "./LongFormModalRow.vue?vue&type=script&lang=js"
export * from "./LongFormModalRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports